import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconFont: 'fa',
    },
    // theme: {
    //     themes: {
    //         light: {
    //             primary: colors.purple.darken1, // #E53935
    //             secondary: colors.red.lighten4, // #FFCDD2
    //             accent: colors.indigo.base, // #3F51B5
    //         },
    //     },
    // },
});
